<template>
  <div class="order_page_style">
    <el-page-header @back="goBack" class="pc_hide_style"> </el-page-header>
    <div class="new_order_style">账单和物流</div>
    <div class="fee_style">支出：￥{{ order_amount }}</div>
    <div v-for="item in order_list" :key="item.orderId">
      <el-collapse accordion v-model="activeName" @change="order_change_click">
        <el-collapse-item :name="item.orderId">
          <template slot="title">
            <div class="pack_style">
              <!-- <div class="new_pack_name_style">{{ item.packageName }}</div> -->
              <!-- <div class="new_pack_name_style">{{ item.orderId }}</div> -->
              <div class="new_pack_name_style">
                家庭配置药基础系列 {{ item.createTime }}
              </div>
              <div class="new_pack_name_style">￥{{ item.rmbAmount }}</div>
            </div>
          </template>
          <!-- <div v-if="item.payStatus == -1">已取消</div>
          <div v-if="item.payStatus == 0">待支付</div>
          <div v-if="item.payStatus == 1">已支付</div> -->
          <el-descriptions :column="1" :colon="false" border>
            <el-descriptions-item label="编号">{{
              item.orderId
            }}</el-descriptions-item>
            <el-descriptions-item label="创建时间">{{
              item.createTime
            }}</el-descriptions-item>
            <el-descriptions-item label="支付状态">
              <!-- <el-tag v-if="item.payStatus == -1" size="small" type="danger"
                >已取消</el-tag
              > -->
              <el-tag v-if="item.payStatus == 0" size="small" type="warning">{{
                待支付
              }}</el-tag>
              <el-tag v-if="item.payStatus == 1" size="small">{{
                已支付
              }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="支付方式">
              <div v-if="item.payStatus == 0">
                <el-radio v-model="item.vendor" label="wechatpay" size="mini">{{
                  微信
                }}</el-radio>
                <el-radio v-model="item.vendor" label="alipay" size="mini">{{
                  支付宝
                }}</el-radio>
                <el-radio v-model="item.vendor" label="unionpay" size="mini">{{
                  银联
                }}</el-radio>
                <el-tag
                  class="pay_style"
                  @click="pay_click1(item.orderId, item.vendor)"
                  >支付</el-tag
                >
              </div>
              <div v-if="item.payStatus == 1">
                <el-tag v-if="item.vendor == 'wechatpay'" size="small">{{
                  微信
                }}</el-tag>
                <el-tag v-if="item.vendor == 'alipay'" size="small">{{
                  支付宝
                }}</el-tag>
                <el-tag v-if="item.vendor == 'unionpay'" size="small">{{
                  银联
                }}</el-tag>
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="物流">
              <div v-if="item.payStatus == 0">-</div>
              <el-tag v-if="item.payStatus == 1" size="small" type="warning">{{
                待发货
              }}</el-tag>
              <el-tag
                v-if="item.payStatus == 2"
                size="small"
                class="num_style"
                @click="track_click(item.expressNum)"
                >查看</el-tag
              >
            </el-descriptions-item>
          </el-descriptions>
        </el-collapse-item>
      </el-collapse>
    </div>
    <!-- <el-table :data="order_list" border class="media_style1">
      <el-table-column
        prop="orderId"
        label="编号"
        align="center"
        width="120px"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="rmbAmount"
        label="金额"
        align="center"
        width="120px"
      ></el-table-column>
      <el-table-column prop="payStatus" label="状态" width="120px">
        <template slot-scope="scope">
          <div v-if="scope.row.payStatus == -1">已取消</div>
          <div v-if="scope.row.payStatus == 0">待支付</div>
          <div v-if="scope.row.payStatus == 1">已支付</div>
        </template>
      </el-table-column>
      <el-table-column
        prop=""
        label="省市区"
        align="center"
        width="120px"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.province }}{{ scope.row.city }}{{ scope.row.district }}
        </template>
      </el-table-column>
      <el-table-column
        prop="address"
        label="详细地址"
        align="center"
        width="120px"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="receiving"
        label="收件人"
        align="center"
        width="120px"
      ></el-table-column>
      <el-table-column
        prop="receivingMobile"
        label="收件人手机"
        align="center"
        width="120px"
      ></el-table-column>
      <el-table-column
        prop="expressNum"
        label="快递单号"
        align="center"
        width="120px"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        align="center"
        width="120px"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop=""
        label="操作"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span class="o_style">
            <el-link
              :underline="false"
              type="warning"
              v-if="scope.row.payStatus == -1"
              @click="delete_click(scope.row.orderId)"
              >删除订单</el-link
            >
          </span>
          <span class="o_style"
            ><el-link
              :underline="false"
              type="warning"
              v-if="scope.row.payStatus == 0"
              @click="cancel_click(scope.row.orderId)"
              >取消订单</el-link
            >
          </span>
          <span class="o_style">
            <div v-if="scope.row.payStatus == 0" class="detail_style">
              <div>
                <el-radio
                  v-model="scope.row.vendor"
                  label="wechatpay"
                  border
                  size="mini"
                  >微信</el-radio
                >
                <el-radio
                  v-model="scope.row.vendor"
                  label="alipay"
                  border
                  size="mini"
                  >支付宝</el-radio
                >
                <el-radio
                  v-model="scope.row.vendor"
                  label="unionpay"
                  border
                  size="mini"
                  >银联</el-radio
                >
              </div>
              <el-link
                :underline="false"
                type="primary"
                v-if="scope.row.payStatus == 0"
                @click="pay_click1(scope.row.orderId, scope.row.vendor)"
                >继续支付</el-link
              >
            </div>
          </span>
          <span class="o_style">
            <el-link
              :underline="false"
              type="warning"
              v-if="scope.row.expressNum"
              @click="track_click(scope.row.expressNum)"
              >查看物流</el-link
            >
          </span>
        </template>
      </el-table-column>
    </el-table> -->
    <el-dialog title="物流轨迹" :visible.sync="centerDialogVisible" center>
      <el-timeline>
        <el-timeline-item
          v-for="(item, index) in track_list"
          :key="index"
          :timestamp="item.ftime"
        >
          {{ item.context }}
        </el-timeline-item>
      </el-timeline>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    <el-dialog title="支付" :visible.sync="payDialogVisible" center width="30%">
      <div class="qr_style">
        <qrcode-vue
          :value="nihaopay_qr_code"
          :size="size"
          level="H"
        ></qrcode-vue>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="payDialogVisible = false">关 闭</el-button>
        <el-button type="primary" @click="pay_confirm_click">已支付</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import PcUserLeft from "../components/PcUserLeft.vue";
import MobileOrder from "../components/MobileOrder.vue";
export default {
  computed: {
    ...mapState(["cgmUserVO"]),
  },
  components: {
    PcUserLeft,
    MobileOrder,
  },
  data() {
    return {
      size: 300,
      nihaopay_qr_code: null,
      payDialogVisible: false,
      order_list: [],
      centerDialogVisible: false,
      track_list: [],
      activeName: null,
      order_amount: 0,
    };
  },
  mounted() {
    this.cgmOrderList();
    this.cgmOrderAmount();
  },
  methods: {
    goBack() {
      // this.$router.back()
      this.$router.push({
        path: "/menu",
      });
    },
    order_change_click(v) {
      this.activeName = v;
    },
    cancel_click(orderId) {
      this.axios
        .post(
          "/cgmOrder/cancel",
          {
            orderId,
          },
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 200) {
            this.cgmOrderList();
            this.$message({ type: "success", message: "订单已取消" });
          }
        });
    },
    delete_click(orderId) {
      this.axios
        .post(
          "/cgmOrder/delete",
          {
            orderId,
          },
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 200) {
            this.cgmOrderList();
            this.$message({ type: "success", message: "订单已删除" });
          }
        });
    },
    pay_confirm_click() {
      this.cgmOrderList();
      this.payDialogVisible = false;
    },
    pay_click(codeUrl) {
      this.nihaopay_qr_code = codeUrl;
      this.payDialogVisible = true;
    },
    pay_click1(orderId, vendor) {
      this.axios
        .post(
          "/reSecurePay",
          {
            orderId,
            vendor,
          },
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 200) {
            let w = window.open("", "_self");
            w.document.write(res.data.data);
          }
        });
    },
    track_click(expressNum) {
      this.axios
        .get("/track", {
          params: {
            expressNum,
          },
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.centerDialogVisible = true;
            this.track_list = JSON.parse(res.data.data);
          }
        });
    },
    cgmOrderList() {
      let userId = JSON.parse(this.cgmUserVO).userId;
      this.axios
        .get("/cgmOrder/getOrderByUserId", {
          params: {
            userId,
          },
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.order_list = res.data.data;
          }
        });
    },
    cgmOrderAmount() {
      let userId = JSON.parse(this.cgmUserVO).userId;
      this.axios
        .get("/cgmOrder/getOrderAmount", {
          params: {
            userId,
          },
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.order_amount = res.data.data;
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@media (min-width: 768px) {
  .pc_hide_style {
    display: none;
  }
}
.pay_style {
  margin-left: 10px;
  cursor: pointer;
}
::v-deep .el-radio__label {
  padding-left: 4px;
  vertical-align: middle;
}
.num_style {
  cursor: pointer;
}
.pack_style {
  display: flex;
  justify-content: space-between;
  width: 94%;
}
.new_pack_name_style {
  font-size: 14px;
  color: #202f3b;
}

::v-deep .el-radio {
  margin-right: 10px;
}
@media (max-width: 768px) {
  ::v-deep .el-dialog {
    width: 100% !important;
  }
  .media_style1 {
    display: none;
  }
  .order_page_style {
    padding: 20px !important;
    margin: 40px 0 80px 0 !important;
    background: unset !important;
  }
}
@media (min-width: 768px) {
  .mobile_hide_style {
    display: none;
  }
}
.new_order_style {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 40px;
}
.fee_style {
  text-align: end;
  font-size: 14px;
  color: #8a8a8a;
  margin-bottom: 20px;
}
.detail_style {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.o_style {
  margin-right: 10px;
  cursor: pointer;
}
.card_style {
  margin-bottom: 10px;
}
.repay_style {
  cursor: pointer;
}
.repay_style1 {
  color: #f56c6c;
}
.pa_style {
  display: flex;
  justify-content: space-around;
}
.pa1_style {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-bottom: 20px;
}
.pa2_style {
  display: flex;
  // justify-content: flex-end;
  align-items: center;
  gap: 10px;
  // margin-bottom: 20px;
}
.order_head {
  display: flex;
  justify-content: space-between;
}
.qr_style {
  display: flex;
  justify-content: center;
}
</style>